export default __webpack_public_path__ + "static/media/brasiliafooter.9897dc6b.png";